import ReactDOM from 'react-dom/client';

import '@backstage/cli/asset-types';
import '@backstage/ui/css/styles.css';

import '@spotify/confidence-app-theme/css/app-styles.css';
import '@spotify/confidence-dev-instrumentation/patchJsxSource';
import '@spotify/confidence-encore-foundation/css/encore-text-styles.css';
import '@spotify/confidence-encore-foundation/css/fonts.css';

import app from './App';
import './bootstrap';

ReactDOM.createRoot(document.getElementById('root')!).render(app);
